import React from 'react'

import BaseAssemblyFormBlock from './BaseAssemblyFormBlock'

const AutoBoatShowFormBlock = () => {
  return <BaseAssemblyFormBlock formId='4956657' height='600' />
}

export default React.memo(AutoBoatShowFormBlock)
